(function () {
  const campaignCode = 'JESEN';
  const firstPurchaseCode = 'PRVY_NAKUP_10';
  const firstPurchaseSessionKey = 'salabom-first-purchase-discount';
  const campaignEnd = new Date('2026-09-20T23:59:59+02:00').getTime();
  const watchedForms = new WeakSet();
  let firstPurchaseEligible = false;
  let updateInProgress = false;
  let updateRequested = false;

  const cartPath = (window.routes?.cart_url || '/cart').replace(/\/$/, '');
  const linkedCodes = new URLSearchParams(window.location.search).get('discount')?.split(',').map((code) => code.trim());
  const firstPurchaseLink =
    window.location.pathname.replace(/\/$/, '') === cartPath &&
    linkedCodes?.length === 2 &&
    linkedCodes.includes(campaignCode) &&
    linkedCodes.includes(firstPurchaseCode);

  try {
    firstPurchaseEligible = firstPurchaseLink || sessionStorage.getItem(firstPurchaseSessionKey) === '1';
    if (firstPurchaseLink) sessionStorage.setItem(firstPurchaseSessionKey, '1');
  } catch (error) {
    // The link still applies the code on this page when storage is blocked.
    firstPurchaseEligible = firstPurchaseLink;
  }

  function discountCodes() {
    const codes = [];
    if (Date.now() <= campaignEnd) codes.push(campaignCode);
    if (firstPurchaseEligible) codes.push(firstPurchaseCode);
    return codes.join(',');
  }

  window.salabomDiscountCodes = discountCodes;

  function replaceElement(sectionHtml, selector) {
    if (!sectionHtml) return;

    const currentElement = document.querySelector(selector);
    const nextElement = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector(selector);

    if (currentElement && nextElement) currentElement.replaceWith(nextElement);
  }

  async function applyDiscounts() {
    if (updateInProgress) {
      updateRequested = true;
      return;
    }

    const codes = discountCodes();
    if (!codes) return;

    updateInProgress = true;
    const updateUrl = window.routes?.cart_update_url || `${window.Shopify?.routes?.root || '/'}cart/update.js`;
    const cartItemsSectionId = document.querySelector('#main-cart-items')?.dataset.id;
    const cartFooterSectionId = document.querySelector('#main-cart-footer')?.dataset.id;
    const sections = ['cart-icon-bubble', 'cart-drawer', cartItemsSectionId, cartFooterSectionId].filter(Boolean);

    try {
      const response = await fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          discount: codes,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      if (!response.ok) throw new Error(`Discount request failed with status ${response.status}`);

      const cart = await response.json();
      if (cart.sections) {
        // Replace the icon first so a newly rendered cart drawer binds to the current icon.
        replaceElement(cart.sections['cart-icon-bubble'], '#cart-icon-bubble');
        replaceElement(cart.sections['cart-drawer'], 'cart-drawer');
        replaceElement(cart.sections[cartItemsSectionId], 'cart-items');
        replaceElement(cart.sections[cartFooterSectionId], '#main-cart-footer');
      }
    } catch (error) {
      console.warn('Zľavové kódy sa nepodarilo automaticky aktivovať.', error);
    } finally {
      updateInProgress = false;
      if (updateRequested) {
        updateRequested = false;
        applyDiscounts();
      }
    }
  }

  function checkFormSuccess(root) {
    const successStep = root.querySelector('#app-embed[data-current-step="success"], [data-testid="banner-success"]');
    if (!successStep || !root.textContent.includes(firstPurchaseCode) || firstPurchaseEligible) return;

    firstPurchaseEligible = true;
    try {
      sessionStorage.setItem(firstPurchaseSessionKey, '1');
    } catch (error) {
      // Keep the discount active on this page even when storage is blocked.
    }
    applyDiscounts();
  }

  function watchForms() {
    document.querySelectorAll('shopify-forms-embed, form-embed').forEach(function (form) {
      const root = form.shadowRoot;
      if (!root) return;

      if (!watchedForms.has(root)) {
        watchedForms.add(root);
        new MutationObserver(function () {
          checkFormSuccess(root);
        }).observe(root, { attributes: true, childList: true, subtree: true });
      }
      checkFormSuccess(root);
    });
  }

  // Shopify Forms inserts its shadow-root popup after the theme has loaded.
  watchForms();
  new MutationObserver(watchForms).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(watchForms, 1000);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event?.discountsSynced && !updateInProgress) return;
      return applyDiscounts();
    });
  }

  applyDiscounts();
})();
